import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import DawlanceSelection from "../Selection2/DawlanceSelection";
import AzelSelection from "../Selection2/AzelSelection";
import AzelShow from "./commercialimagesshow/AzelShow";
import WanderSelection from "../Selection2/WanderSelection";
import WanderShow from "./commercialimagesshow/WanderShow";

export default function WanderComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/12-WanderChocolateShowroom/1.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">
                {" "}
                Wander Chocolate
                <br />
                Showroom
              </p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: Architectural drawings, 3d drawings, project
                  execution
                </span>
                <span>project duration: 3 months</span>
                <span>year of completion: 2022</span>
                <span>project location:Bursa-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>
        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "35px",
                  textTransform: "uppercase",
                  padding: "50px",
                }}
              >
                Wander Chocolate blends luxury, style, and functionality,
                creating a sensory shopping experience with custom designs and
                high-end materials
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              This project showcases the design of Wander Chocolate, a boutique
              chocolate store that reshapes the idea of luxury retail through
              its smooth combination of style and practicality. The
              architectural concept focuses on a welcoming and eye-catching
              storefront with arched windows and modern branding that draws
              attention. Inside, the design carries forward a balanced mix of
              materials, featuring custom shelving, intricate details, and a
              carefully arranged display area. The addition of coffee counters
              introduces a functional aspect, inviting customers to enjoy a
              complete sensory experience. Every element, from the lighting to
              the choice of materials, is planned to enhance the shopping
              experience while reflecting the high quality of the brand.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/CommercialImages/12-WanderChocolateShowroom/7.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
   

        {/* <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              "Wander Chocolate blends luxury, style, and functionality,
              creating a sensory shopping experience with custom designs and
              high-end materials."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="../../Images/CommercialImages/12-WanderChocolateShowroom/8.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section> */}



     

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                “Wander Chocolate’s boutique reimagines luxury with every
                detail, from its elegant arches to its inviting interiors."
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        {/* <AzelShow /> */}
        <WanderShow/>
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
